import React, { useState } from 'react';
import Select from 'react-select';
import CodeBlock from "@components/codeblock"

import '@theme/cards/master.css'

// The following is pretty self explanatory,
// however ensure that your codefield is wrapped in ""
// Otherwise React will not pick this up as a string and throw and error.

const options = [
  {
    value: 'card container',
    label: 'Card Container',
    codeField: `<div class="nds_card"></div>`
  },
  {
    value: 'elevated card',
    label: 'Elevated Card',
    codeField: `
<div class="nds_card elevated"></div>`
  },
  {
    value: 'card with buttons',
    label: 'Card with Buttons',
    codeField: `
<div class="nds_card">
  <div class="nds_card_btn_container">
    <button type="button" class="tertiary">Go Back</button>
    <button type="button" class="primary">Continue</button>
  </div>
</div>`
  },
  {
    value: 'card with text',
    label: 'Card with Text',
    codeField: `
<div class="nds_card">
  <div class="nds_card_heading">Heading</div>
  <div class="nds_card_text">For those who have seen the Earth from space, and for the hundreds and perhaps thousands more who will, the experience most certainly changes your perspective.</div>
  <div class="nds_card_text">The things that we share in our world are far more valuable than those which divide us.</div>
</div>`
  },
  {
    value: 'card with table',
    label: 'Card with Table',
    codeField: `
<div class="nds_card nds_card_table">


<table>
<thead>
  <tr>
    <th>Column A</th>
    <th>Column B</th>
    <th>Column C</th>
    <th>Column D</th>
  </tr>
</thead>
<tbody>
  <tr>
    <td>Column A</td>
    <td>Column B</td>
    <td>Column C</td>
    <td>Column D</td>
  </tr>
  <tr>
    <td>Column A</td>
    <td>Column B</td>
    <td>Column C</td>
    <td>Column D</td>
  </tr>
  <tr>
    <td>Column A</td>
    <td>Column B</td>
    <td>Column C</td>
    <td>Column D</td>
  </tr>
</tbody>
</table>
</div>`
  },
  {
    value: 'card with image',
    label: 'Card with Image',
    codeField: `
<div class="nds_card nds_card_image">
<div class="nds_card_placeholder"></div>
<div class="nds_card_heading">Heading</div>
</div>`
  },
  ];


const defaultSate = options[0].codeField

function CardStates() {
  //  Please ensure that your useState value contains the default value for your component
  // Otherwise nothing will show on initial render.
    const [selectedValue, setSelectedValue] = useState(defaultSate);
 
    const handleChange = e => {
      setSelectedValue(e.codeField);
    }
  
    return (
    <>
        <Select
         className="slDrp"
          placeholder="Select Option"
          value={options.filter(obj => obj.codeField === selectedValue)} // set selected value
          onChange={handleChange}
          options={options}
        />
        <CodeBlock value={selectedValue} live={true}>{selectedValue}</CodeBlock>
    </>
    );
    }

export default CardStates